import type { ProviderName } from '@repo/api-codegen';

export const SSO_NAMES: Record<ProviderName, string> & {
	none: string;
	saml: string;
} = {
	google: 'Google',
	microsoft: 'Microsoft',
	saml: 'SAML',
	none: 'None',
	generic: 'Generic',
	okta: 'Okta',
	onelogin: 'OneLogin',
};

export type SsoTypes = keyof typeof SSO_NAMES;

export const getSsoName = (sso: SsoTypes) => {
	if (!sso) {
		return '';
	}
	return SSO_NAMES[sso];
};
